import bg from '../assets/bg.png';
import chef from '../assets/chef.png';
import G from '../assets/G.png';
import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png';

import gallery_01 from '../assets/gallery-01.jpg';
import gallery_02 from '../assets/gallery-02.jpg';
import gallery_03 from '../assets/gallery-03.jpg';
import gallery_04 from '../assets/gallery-04.jpg';
import gallery_05 from '../assets/gallery-05.jpg';
import gallery_06 from '../assets/gallery-06.jpg';
import gallery_07 from '../assets/gallery-07.jpg';

import gallery_image_01 from '../assets/Gallery/gallery_01.jpg'
import gallery_image_02 from '../assets/Gallery/gallery_02.jpg'
import gallery_image_03 from '../assets/Gallery/gallery_03.jpg'
import gallery_image_04 from '../assets/Gallery/gallery_04.jpg'
import gallery_image_05 from '../assets/Gallery/gallery_05.jpg'
import gallery_image_06 from '../assets/Gallery/gallery_06.jpg'
import gallery_image_07 from '../assets/Gallery/gallery_07.jpg'
import gallery_image_08 from '../assets/Gallery/gallery_08.jpg'
import gallery_image_09 from '../assets/Gallery/gallery_09.jpg'
import gallery_image_10 from '../assets/Gallery/gallery_10.jpg'
import gallery_image_11 from '../assets/Gallery/gallery_11.jpg'
import gallery_image_12 from '../assets/Gallery/gallery_12.jpg'
import gallery_image_13 from '../assets/Gallery/gallery_13.jpg'
import gallery_image_14 from '../assets/Gallery/gallery_14.jpg'
import gallery_image_15 from '../assets/Gallery/gallery_15.jpg'
import gallery_image_16 from '../assets/Gallery/gallery_16.jpg'
import gallery_image_17 from '../assets/Gallery/gallery_17.jpg'
import gallery_image_18 from '../assets/Gallery/gallery_18.jpg'
import gallery_image_19 from '../assets/Gallery/gallery_19.jpg'
import gallery_image_20 from '../assets/Gallery/gallery_20.jpg'

import knife from '../assets/knife.png';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.png';
import findus from '../assets/findus.png';
import laurels from '../assets/laurels.png';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import gericht from '../assets/gericht.png';
import cake from '../assets/cake.png';
import building from '../assets/building.png';
import about_image from '../assets/about_image.png';
import cakeSpecialMenu from '../assets/cakeSpecialMenu.png';
import coverAboutUs from '../assets/coverAboutUs.jpg'
import principalmenu_coffee from '../assets/Principalmenu-coffee.jpg'
import principalmenu_bread from '../assets/Principalmenu-bread.jpg'
import principalmenu_tart from '../assets/Principalmenu-tart.jpg'
import principalmenu_pastry from '../assets/Principalmenu-pastry.jpg'

const images = {
  bg,
  chef,
  G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  logo,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  gericht,
  cake,
  building,
  about_image,
  gallery_01,
  gallery_02,
  gallery_03,
  gallery_04,
  gallery_05,
  gallery_06,
  gallery_07,
  cakeSpecialMenu,
  coverAboutUs,
  principalmenu_coffee,
  principalmenu_bread,
  principalmenu_tart ,
  principalmenu_pastry,
  gallery_image_01,
  gallery_image_02,
  gallery_image_03,
  gallery_image_04,
  gallery_image_05,
  gallery_image_06,
  gallery_image_07,
  gallery_image_08,
  gallery_image_09,
  gallery_image_10,
  gallery_image_11,
  gallery_image_12,
  gallery_image_13,
  gallery_image_14,
  gallery_image_15,
  gallery_image_16,
  gallery_image_17,
  gallery_image_18,
  gallery_image_19,
  gallery_image_20
};


export default images;